export const MONEY_SEPARATOR = ' ';
export const getFormattedAmount = (amount: string) => {
    const formattedAmount = amount.replace(/\B(?=(\d{3})+(?!\d))/g, MONEY_SEPARATOR);
    return `${formattedAmount} ₽`;
};
